









































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import { PageInfo } from "@/model/Resp";
import { TFlowVO } from "@/model/FlowDetailVO";
import { getPickerOptions, dateFormat, getWeekFirstDay } from "@/services/common";
import {
  getFlowList,
  pauseFlowDetail,
  deleteFlowDetail,
  runFlowDetail,
  getCampaignList,
  getFlowDetail,
  flowReply
} from "@/services/api";

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
  },
})
export default class MarketingProcess extends Vue {
  public tableData: TFlowVO[] = [];

  public pageInfo: PageInfo = {
    currentPage: 1,
    pageSize: 20,
    total: 0,
  };

  public typeList = [
    {
      show: "触发型-完成 A",
      en: "TRIGGER_A",
    },
    {
      show: "触发型-完成 A 未完成 B",
      en: "TRIGGER_A_NOT_B",
    },
    {
      show: "触发型-进入A用户群",
      en: "TRIGGER_A_FENQUN",
    },
  ];

  // 初始提示弹框
  public dialogVisible = false;

pickerOptions = getPickerOptions()
value1 = 0
// 初始默认选中本周
date = [getWeekFirstDay(),new Date()]

  options = [{
    value: 0,
    label: '全部'
  }, {
    value: 2,
    label: '运行中'
  }, {
    value: 1,
    label: '草稿'
  }, {
    value: 3,
    label: '暂停中'
  }]
  order = null
  prop = null
  loading = false


  created(): void {
    this.getFlowList();
  }

  // 新增挂载完成监听
  mounted() {
    // 挂载完成，判断sessionStorate里是否首次创建, 因为跨页面，而且只用一次，就不内部router传参了。
    const isFirstFlow = sessionStorage.getItem("isFirstFlow");
    if (isFirstFlow === "1") {
      this.dialogVisible = true;
      sessionStorage.removeItem("isFirstFlow");
    }
  }

  formatterChange(r: any, c: any, v: any) { return v === 0 ? 0 : (v || '-') }

  formatterChangeGMV(r: any, c: any, v: any) { return v === 0 ? '$0' : (`$${v}` || '-') }

  getclass(scope: any) { return '__status--' + { 1: 'draft', 2: 'running', 3: 'suspend' }[scope.row.status as 1 | 2 | 3] }

  getFlowList(order?: string, prop?: string) {
    this.loading = true

    let sendDateStart = this.date ? (typeof (this.date[0]) == 'string' ? this.date[0] : dateFormat('YYYY-mm-dd 00:00:00', this.date[0])) : null
    let sendDateEnd = this.date ? (typeof (this.date[1]) == 'string' ? this.date[1] : dateFormat('YYYY-mm-dd 00:00:00', this.date[1])) : null

    let params = {
      dateStart: sendDateStart,
      dateEnd: sendDateEnd,
      status: this.value1,
      currentPage: this.pageInfo.currentPage,
      pageSize: this.pageInfo.pageSize,
      sortType: this.order && (this.order === 'ascending' ? 'ASC' : 'DESC'),
      sortColumn: this.order && this.prop
    }
    getFlowList(params).then((res) => {
      this.tableData = res.data.data;
      this.loading = false
      if (res.data.pageInfo) {
        this.pageInfo = res.data.pageInfo;
      }
    });
  }

  /**
   * 暂停流程
   */
  async pauseFlow(id: number) {
    await this.$confirm(
      "确定暂停该流程吗？已进入流程的用户不会退出，重启流程会判断用户是否满足后续策略器的执行条件！",
      "确定暂停吗？",
      {customClass:'modalOk'}
    );
    pauseFlowDetail({ id }, true).then((res) => {
      this.getFlowList();
      const app: any = document.querySelector("#app");
      app.click();
    });
  }

  /**
   * 回溯流程
   */
  async recallFlow(row) {
    await this.$msgbox({
      message: `<div>
        <h5 class="recall-title">回溯历史用户</h5>
        <p class="recall-content">
          当您启用一个新的，或是重新启用一个暂停很久的营销流程时，启用前满足触发条件的用户不会再进入流程，如果想召回这部分用户，可以操作回溯功能。
          点击<a href="https://www.yuque.com/xuyang-i9idz/nywmyg/ifcw5z5u82l3g7ii" target="_blank" class="more-info">了解更多信息</a>
        </p>
    </div>`,
      showClose: false,
      confirmButtonText: '回 溯',
      dangerouslyUseHTMLString: true,
      customClass: 'recall-confirm',
      confirmButtonClass: 'confirm-btn',
      cancelButtonClass: 'cancel-btn',
      showCancelButton: true
    }).then(() => {
      // console.log(row, 'row')
      getFlowDetail({id: row?.id }).then(res => {
        // console.log(res, 'resres');
        // 包含延迟发送时间
       if (res?.data?.data?.strategyUnitList.some(item => item.delayConfig.value !== 0)) {
        // 请求后端
        flowReply({id: row?.id }).then(res => {
          if (res?.data.message === 'success') {
            this.$message.success('流程回溯成功')
          }
        })
       } else {
        this.$message.success('流程回溯成功')
       }
      })
    }).catch(() => { });
  }

  /**
   * 删除流程
   */
  async deleteFlow(id: number) {
    await this.$confirm(
      "确定删除该流程吗？删除后无法恢复！",
      "确定删除吗？",
      {customClass:'modalOk'}
    );
    deleteFlowDetail({ id }, true).then((res) => {
      this.getFlowList();
      const app: any = document.querySelector("#app");
      app.click();
    });
  }

  /**
   * 启用流程
   */
  runFlow(id: number) {
    runFlowDetail({ id }, true).then((res: any) => {
      // 判断是否首次
      if (res?.data?.data?.firstFlow) {
        this.dialogVisible = true;
      }
      this.getFlowList();
      const app: any = document.querySelector("#app");
      app.click();
    });
  }

  /**
   * 查询
   */
  search(): void {
    this.pageInfo.currentPage = 1;
    this.getFlowList();
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.pageInfo.pageSize = val;
    this.pageInfo.currentPage = 1;
    this.getFlowList();
  }

  // 时间变化
  changeDate(e: Date[]) {
    this.getFlowList();
  }
  // 活动状态变化
  changeValue1(e: string) {
    this.getFlowList();
  }

  //列表排序
  sortChange(data: any) {
    this.order = data.order
    this.prop = data.prop.slice(11)
    this.getFlowList();
  }


  PercentageContrast(a: string, b: string): number | undefined {
    if (typeof (a) == 'string' && typeof (b) == 'string') {
      return Number(a.replace("%", "")) - Number(b.replace("%", ""))
    } else {
      Number(a) - Number(b)
    }
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.pageInfo.currentPage = val;
    this.getFlowList();
  }
}
